import React from "react";
import { Navigate, useLocation } from "react-router";

/** Sends an old bookmark to the page's new home, keeping whatever followed the old prefix and the query string. */
export const LegacyRedirect = ({ from, to }: { from: string; to: string }) => {
  const { pathname, search } = useLocation();
  return <Navigate replace to={`${to}${pathname.slice(from.length)}${search}`} />;
};
